import {
  colours,
  build as constants,
  getHash,
  job as jobConstants,
  jobNames,
  metrics as metricConstants,
  metricsPagesHelper,
  pageTypes,
  params as paramConstants,
  reducerHelpers,
  scan as scanConstants,
  utils
} from './../helpers';

import {
  buildIdsByJobId,
  buildsById,
  buildsByTypesAndProducts,
  dispatchersByJobIds,
  filterBuilds,
  filterBuildsByProduct,
  findLatestDispatcherFromTypeGroups,
  getBaselineBuildInfo,
  getBuildInfo,
  getConcerningMetricsOnly,
  getHighlightedMetricImage,
  getLatestMetricsOnly,
  getMetricsByDateLowerLatestFetch,
  getMetricsByDateRunCount,
  getMetricsByDateTimestamp,
  getMetricsByDateUpperLatestFetch,
  getMetricsDispatcherType,
  getMetricsJobName,
  getMetricsOutliersShown,
  getMetricsPageInfo,
  getMetricsPageSelectedJob,
  getMetricsPageDropdownFirstSelected,
  getMetricsSorter,
  getShowBuildComplement,
  groupDispatchersByType,
  groupJobRelationshipsByParentJobId,
  groupJobsByName,
  groupScenariosByDispatcherId,
  jobIdsByBuildId,
  jobsById,
  latestImageBaselineBuildIds,
  latestImageBaselineJobIds,
  latestReleaseBuildByProducts,
  metricsByJobIds,
  paramsByJobIds,
  scansByJobId
} from './index';

import * as annotationsReducer from './annotations';
import * as artifactsMetricsPageReducer from './artifactsMetricsPage';
import * as buildHealthPageReducer from './buildHealthPage';
import * as buildPageReducer from './buildPage';
import * as buildsReducer from './builds';
import * as caseAmendingPerformancePageReducer from './caseAmendingPerformancePage';
import * as caseAmendingKppPerformancePageReducer from './caseAmendingKppPerformancePage';
import * as caseMetricsPageReducer from './caseMetricsPage';
import * as commonPageInfoReducer from './commonPageInfo';
import * as dispatchersReducer from './dispatchers';
import * as engineMetricsPageReducer from './engineMetricsPage';
import * as exportPerformancePageReducer from './exportPerformancePage';
import * as installerDifferencesReducer from './installerDifferences';
import * as installerTestsReducer from './installerTestExpected';
import * as jobLabelsReducer from './jobLabels';
import * as failedTestArtifactsReducer from './failedTestArtifacts';
import * as jobsReducer from './jobs';
import * as jobBenchmarkPerformancePageReducer from './jobBenchmarkPerformancePage';
import * as jobBuildsReducer from './jobBuilds';
import * as jobRelationshipReducer from './jobRelationships';
import * as jobScenariosReducer from './jobScenarios';
import * as metricPageReducer from './metricsPage';
import * as metricsReducer from './metrics';
import * as metricsByDateInfoReducer from './metricsByDateInfo';
import * as modalReducer from './modal';
import * as nodeHealthPageReducer from './nodeHealthPage';
import * as nodeIssuesReducer from './nodeIssues';
import * as paramsReducer from './params';
import * as performanceMetricsPageReducer from './performanceMetricsPage';
import * as profileReducer from './profile';
import * as regressionPageReducer from './regressionPage';
import * as releaseMetricsPageReducer from './releaseMetricsPage';
import * as routerExtraReducer from './routerExtra';
import * as scenarioReducer from './scenarios';
import * as toastReducer from './toasts';

import dispatchers, { dispatchersByTypesAfterCaseMetricsDate } from './dispatchers';
import {
  flatten,
  intersectionBy,
  isEmpty,
  keys,
  last,
  mapValues,
  memoize,
  some,
  uniq
} from 'lodash';
import jobLabels, { jobLabelsByJobId } from './jobLabels';
import jobs from './jobs';
import metricsPage,
{
  getMetricsDispatcherJobName,
  getMetricsPageType
} from './metricsPage';
import Moment from 'moment';

import acquireTelemetryPage from './acquireTelemetryPage';
import acquisitionsMetricsPage from './acquisitionsMetricsPage';
import acquisitionsPage from './acquisitionsPage';
import annotations from './annotations';
import artifactHealth from './artifactHealth';
import artifactsMetricsPage from './artifactsMetricsPage';
import awsPageInfo from './awsPageInfo';
import awsInstances from './awsInstances';
import buildPage from './buildPage';
import builds from './builds';
import buildHealthPage from './buildHealthPage';
import caseAmendingPerformancePage from './caseAmendingPerformancePage';
import caseAmendingKppPerformancePage from './caseAmendingKppPerformancePage';
import caseMetricsPage from './caseMetricsPage';
import cloudAcquisitionBuildInfo from './cloudAcquisitionBuildInfo';
import cloudAcquisitions from './cloudAcquisitions';
import { combineReducers } from 'redux';
import commonPageInfo from './commonPageInfo';
import { createSelector } from 'reselect';
import engineMetricsPage from './engineMetricsPage';
import exportPerformancePage from './exportPerformancePage';
import failedTestArtifacts from './failedTestArtifacts';
import installerDifferences from './installerDifferences';
import installerTestExpected from './installerTestExpected';
import jiraStatuses from './jiraStatus';
import jobBenchmarkPerformancePage from './jobBenchmarkPerformancePage';
import jobBuilds from './jobBuilds';
import jobRelationships from './jobRelationships';
import jobScenarios from './jobScenarios';
import latestImageBaselines from './latestImageBaselines';
import metricTestNodes from './metricTestNodes';
import metrics from './metrics';
import metricsByDateInfo from './metricsByDateInfo';
import modal from './modal';
import nodeHealthPage from './nodeHealthPage';
import nodeIssues from './nodeIssues';
import notificationRequests from './notificationRequests';
import notificationRules from './notificationRules';
import params from './params';
import performanceMetricsPage from './performanceMetricsPage';
import profile from './profile';
import toasts from './toasts';
import regressionPage from './regressionPage';
import axiomTelemetryPage from './axiomTelemetryPage';
import releaseMetricsPage from './releaseMetricsPage';
import { routerReducer } from 'react-router-redux';
import scans from './scans';
import scenarios from './scenarios';
import sonar from './sonar';
import { reducer as toastrReducer } from 'react-redux-toastr';
import websocket from './websocket';

// old pattern, ...slowly deprecate
export * from './acquireTelemetryPage';
export * from './acquisitionsMetricsPage';
export * from './acquisitionsPage';
export * from './annotations';
export * from './artifactHealth';
export * from './awsPageInfo';
export * from './awsInstances';
export * from './buildPage';
export * from './builds';
export * from './buildHealthPage';
export * from './cloudAcquisitionBuildInfo';
export * from './cloudAcquisitions';
export * from './commonPageInfo';
export * from './dispatchers';
export * from './failedTestArtifacts';
export * from './jiraStatus';
export * from './jobBuilds';
export * from './jobLabels';
export * from './jobRelationships';
export * from './jobs';
export * from './latestImageBaselines';
export * from './metrics';
export * from './metricsByDateInfo';
export * from './metricsPage';
export * from './metricTestNodes';
export * from './modal';
export * from './notificationRequests';
export * from './notificationRules';
export * from './params';
export * from './regressionPage';
export * from './axiomTelemetryPage';
export * from './routerExtra';
export * from './scans';
export * from './scenarios';
export * from './sonar';
export * from './websocket';


const app = combineReducers({
  acquisitionsPage,
  acquisitionsMetricsPage,
  acquireTelemetryPage,
  artifactHealth,
  artifactsMetricsPage,
  annotations,
  awsPageInfo,
  awsInstances,
  buildPage,
  builds,
  buildHealthPage,
  commonPageInfo,
  cloudAcquisitions,
  cloudAcquisitionBuildInfo,
  caseAmendingPerformancePage,
  caseAmendingKppPerformancePage,
  caseMetricsPage,
  dispatchers,
  engineMetricsPage,
  exportPerformancePage,
  failedTestArtifacts,
  installerDifferences,
  installerTestExpected,
  jiraStatuses,
  jobs,
  jobBenchmarkPerformancePage,
  jobBuilds,
  jobLabels,
  jobRelationships,
  jobScenarios,
  latestImageBaselines,
  metricTestNodes,
  metricsByDateInfo,
  metrics,
  metricsPage,
  modal,
  nodeHealthPage,
  nodeIssues,
  notificationRequests,
  notificationRules,
  params,
  performanceMetricsPage,
  profile,
  toasts,
  regressionPage,
  axiomTelemetryPage,
  releaseMetricsPage,
  router: routerReducer,
  scans,
  scenarios,
  sonar,
  toastr: toastrReducer,
  websocket
});

export default app;


// new pattern, to allow for stubbing in tests rather than passing state
export {
  annotationsReducer,
  artifactsMetricsPageReducer,
  buildHealthPageReducer,
  buildPageReducer,
  buildsReducer,
  caseMetricsPageReducer,
  caseAmendingPerformancePageReducer,
  caseAmendingKppPerformancePageReducer,
  commonPageInfoReducer,
  dispatchersReducer,
  engineMetricsPageReducer,
  exportPerformancePageReducer,
  installerDifferencesReducer,
  installerTestsReducer,
  jobLabelsReducer,
  failedTestArtifactsReducer,
  jobsReducer,
  jobBuildsReducer,
  jobBenchmarkPerformancePageReducer,
  jobRelationshipReducer,
  jobScenariosReducer,
  metricPageReducer,
  metricsReducer,
  metricsByDateInfoReducer,
  modalReducer,
  nodeHealthPageReducer,
  nodeIssuesReducer,
  paramsReducer,
  performanceMetricsPageReducer,
  profileReducer,
  regressionPageReducer,
  releaseMetricsPageReducer,
  routerExtraReducer,
  scenarioReducer,
  toastReducer
};

const noFilters = buildInfo => buildInfo.buildType === '' &&
  buildInfo.product === '' &&
  buildInfo.buildNumber === 0;
export const getBuildPageBuilds = createSelector(
  getBuildInfo,
  latestReleaseBuildByProducts,
  filterBuilds,
  (buildInfo, latestReleaseBuildsByProducts, filterBuilds) => {
    if (!noFilters(buildInfo)) {
      if (buildInfo.buildType === constants.LATEST_RELEASE &&
            latestReleaseBuildsByProducts) {
        return constants.getComponentByProduct(buildInfo.product)
          .map(c => latestReleaseBuildsByProducts[c]);
      }

      return filterBuilds(buildInfo);
    }

    return [];
  }
);

const buildPageLatestDispatchersByTypes = createSelector(
  getBuildPageBuilds,
  dispatchersByJobIds,
  jobIdsByBuildId,
  (builds, dispatchersByJobIds, jobIdsByBuildId) => {
    const jobIds = flatten(builds.map(b => jobIdsByBuildId[b.id]))
      .filter(j => j !== undefined);
    const dispatchers = flatten(jobIds.map(id => dispatchersByJobIds[id]));
    const grouped = groupDispatchersByType(dispatchers);
    return findLatestDispatcherFromTypeGroups(grouped);
  }
);
export const getBuildPageLatestDispatcherByType = (state, dispatcherType) =>
  buildPageLatestDispatchersByTypes(state)[dispatcherType];

export const getLatestBaselineBuilds = createSelector(
  buildsById,
  latestImageBaselineBuildIds,
  getBuildInfo,
  (buildsById, latestImageBaselineBuildIds, buildInfo) => {
    const allBuildsByProduct = utils.propertyAccumulatorReducer(
      latestImageBaselineBuildIds.map(id => buildsById[id]).filter(x => x),
      'product'
    );
    return filterBuildsByProduct(allBuildsByProduct, buildInfo.product);
  }
);
export const getLatestBaselineJobs = createSelector(
  jobsById,
  latestImageBaselineJobIds,
  (jobsById, latestImageBaselineJobIds) => latestImageBaselineJobIds
    .map(id => jobsById[id])
    .filter(x => x)
);

export const getBuildPageBaselineBuilds = createSelector(
  getBaselineBuildInfo,
  latestReleaseBuildByProducts,
  filterBuilds,
  getBuildPageBuilds,
  getLatestBaselineBuilds,
  (
    baselineBuildInfo,
    latestReleaseBuildsByProducts,
    filteredBuilds,
    buildPageBuilds,
    latestBaselineBuilds
  ) => {
    if (baselineBuildInfo.buildType === constants.LATEST_BY_IMAGE) {
      return latestBaselineBuilds;
    }

    const hasAllBaselineBuildInfo =
      baselineBuildInfo.buildType !== '' &&
      baselineBuildInfo.product !== '' &&
      baselineBuildInfo.buildNumber !== 0;
    return hasAllBaselineBuildInfo ?
      filteredBuilds(baselineBuildInfo) :
      latestReleaseBuildsByProducts ?
        buildPageBuilds.map(b => latestReleaseBuildsByProducts[b.product]) :
        [];
  }
);

export const getAllBuildPageBuilds = createSelector(
  getBaselineBuildInfo,
  getBuildPageBuilds,
  getBuildPageBaselineBuilds,
  (baselineBuildInfo, builds, baselineBuilds) =>
    utils.uniqArrayCombinator(b => b.id, builds, baselineBuilds)
);

export const metricsPageLatestFetchedJobs = createSelector(
  groupJobsByName,
  getMetricsByDateLowerLatestFetch,
  getMetricsByDateUpperLatestFetch,
  (jobs, lower, upper) => memoize((jobName) => {
    const jobNames = flatten([jobName]);
    if (!jobs ||
      !jobNames.some(name => jobs[name]))
    { return []; }
    let result = [];
    jobNames.forEach(
      name =>
      {
        const tempJobs = jobs[name].filter(j => {
          const jobTimestamp = Moment(j.created_at, 'YYYY-MM-DD HH:mm:ss').unix();
          return jobTimestamp >= lower && jobTimestamp <= upper;
        });
        result = result.concat(tempJobs);
      }
    );
    return result;
  })
);

export const metricsJobsAfterDate = createSelector(
  groupJobsByName,
  getMetricsByDateTimestamp,
  (jobs, timestamp) => memoize((jobName) => {
    if (!jobs || !jobs[jobName]) { return []; }
    const result = jobs[jobName].filter(j =>
      Moment(j.created_at, 'YYYY-MM-DD HH:mm:ss').unix() >= timestamp);
    return result;
  })
);

export const metricsJobsByParamSimple = createSelector(
  metricsJobsAfterDate,
  paramsByJobIds,
  (jobs, paramsByJobIds) => memoize(
    ({ jobName, paramKey }) =>
      utils.propertyAccumulatorReducerByFunc(
        jobs(jobName),
        (job) => {
          const param = paramsByJobIds[job.id];
          return param ? param[paramKey] : undefined;
        }
      )
  )
);

export const metricsJobsByImages = createSelector(
  metricsJobsAfterDate,
  paramsByJobIds,
  (jobs, paramsByJobIds) => utils.propertyAccumulatorReducerByFunc(
    jobs(jobNames.CASE_METRICS),
    (job) => {
      const param = paramsByJobIds[job.id];
      // strip the file extension
      const image = param ? param[paramConstants.IMAGEFILE] : undefined;
      const lastIndex = image ? image.lastIndexOf('.') : undefined;
      return lastIndex ? image.slice(0, lastIndex).toLowerCase() : undefined;
    }
  )
);

export const metricsJobsByScenarioNames = createSelector(
  metricsJobsAfterDate,
  paramsByJobIds,
  (jobs, paramsByJobIds) => memoize(
    (jobName) =>
    {
      const result = {};
      flatten([jobName]).forEach(name =>
      {
        jobs(name).forEach(
          job => {
            if (job === undefined || paramsByJobIds[job.id] === undefined) {
              return result;
            }
            const dispatcherScenarioName =
             paramConstants.JENKINS_DISPATCHER_SCENARIO_NAME.substring(
               paramConstants.JENKINS_ENV_PREFIX.length);
            const filteredParams = paramConstants.cleanParams(
              paramsByJobIds[job.id],
              [paramConstants.JENKINS_DISPATCHER_SCENARIO_NAME]);
            const scenarioName = filteredParams[dispatcherScenarioName] ?
              filteredParams[dispatcherScenarioName].toLowerCase() : '';
            result[scenarioName] === undefined ?
              result[scenarioName] = new Array(job) : result[scenarioName].push(job);
          }
        );
      });
      return result;
    }
  )
);

export const metricsJobsByCaseActions = createSelector(
  metricsJobsAfterDate,
  metricsByJobIds,
  (jobs, metricsByJobIds) => jobs(jobNames.PERFORMANCE).reduce(
    (result, job) => {
      if (job === undefined) {
        return result;
      }
      const metrics = metricsByJobIds[job.id];
      keys(metrics).forEach(metricsName => {
        if (metricsName.includes('|')) {
          result[metricsName] === undefined ?
            result[metricsName] = new Array(job) : result[metricsName].push(job);
        }
      });
      return result;
    }, {}
  )
);

export const metricJobsByBuildType = createSelector(
  metricsJobsAfterDate,
  buildsById,
  buildIdsByJobId,
  (jobs, buildsById, buildIdsByJobId) => memoize(
    (jobName) =>
    {
      const result = utils.propertyAccumulatorReducerByFunc(
        jobs(jobName),
        (job) => {
          const builds = (buildIdsByJobId[job.id] || []).map(id => buildsById[id]);
          const mappedBuilds = builds.map(b => {
            if (!b) { return undefined; }
            const buildTypes = constants.buildTypesMapper(b);
            // grab the last one in case build was also released
            return buildTypes[buildTypes.length - 1];
          });
          return mappedBuilds;
        },
        true
      );
      return result;
    })
);

export const metricJobsByOutlierToggle = createSelector(
  metricsJobsAfterDate,
  getMetricsOutliersShown,
  jobLabelsByJobId,
  (jobs, isShown, jobLabelsByJobId) => memoize(
    (jobName) =>
      jobs(jobName).filter(j => {
        const labels = jobLabelsByJobId[j.id];
        return !(!isShown && labels && labels.some(l => l === 'Outlier'));
      })
  )
);

export const getCaseMetricsImages = createSelector(
  metricsJobsAfterDate,
  paramsByJobIds,
  getMetricsPageInfo,
  groupScenariosByDispatcherId,
  getMetricsPageDropdownFirstSelected,
  getMetricsPageType,
  (jobs, params, info, scenarios, selectedPair, pageType) => {
    // if a dispatcher is selected, find only images
    // for relevant scenarios
    // scenario names have no file extension
    if (selectedPair === metricsPagesHelper.DISPATCHER_MARKER) {
      const sens = scenarios[info.dispatcherId];
      return sens ? sens.map(s => `${s.name.toLowerCase()}`) : [];
    }
    // else find all images
    const imagesHash = jobs(jobNames.CASE_METRICS).reduce((result, j) => {
      const param = params[j.id];
      if (!param || !param[paramConstants.IMAGEFILE]) return result;
      const image = param[paramConstants.IMAGEFILE].toLowerCase();

      // strip the file extension to avoid having to append correct
      // extension when a dispatcher is selected
      const lastIndex = image.lastIndexOf('.');
      const imageName = image.slice(0, lastIndex);
      result[imageName] = imageName;
      return result;
    }, {});

    const unfilteredImages = Object.keys(imagesHash).sort();
    const engineScanPrefix = 'er_';
    if (pageType === pageTypes.CASEMETRICS ||
          pageType === pageTypes.ARTIFACTSMETRICS) {
      const filteredScans = unfilteredImages.filter(i => !i.startsWith(engineScanPrefix));
      return filteredScans;
    }
    if (pageType === pageTypes.ENGINEMETRICS) {
      const filteredEngineScans = unfilteredImages
        .filter(i => i.startsWith(engineScanPrefix));
      return filteredEngineScans;
    }
    return unfilteredImages;
  }
);

export const getRegressionScenarioNames = createSelector(
  metricsJobsAfterDate,
  paramsByJobIds,
  getMetricsPageInfo,
  groupScenariosByDispatcherId,
  (jobs, params, info, scenarios) => {
    if (info.jobName !== jobNames.EXPORT &&
      info.jobName !== jobNames.CASE_AMENDING &&
      info.jobName !== jobNames.CASE_AMENDING_KPP &&
      info.jobName !== jobNames.JOBBENCHMARK) {
      return [];
    }
    const exportScenarioNames = new Set([]);

    if (info.dispatcherId) {
      const sens = scenarios[info.dispatcherId];
      if (sens) {
        return sens.map(s => s.name.toLowerCase());
      }
    }

    const dispatcherScenarioName =
    paramConstants.JENKINS_DISPATCHER_SCENARIO_NAME.substring(
      paramConstants.JENKINS_ENV_PREFIX.length);

    if (!Array.isArray(info.jobName))
    {
      jobs(info.jobName).forEach(
        job => {
          if (params[job.id]) {
            const filteredParams = paramConstants.cleanParams(
              params[job.id],
              [paramConstants.JENKINS_DISPATCHER_SCENARIO_NAME]);
            const scenarioName = filteredParams[dispatcherScenarioName];
            if (scenarioName)
            {
              exportScenarioNames.add(scenarioName.toLowerCase());
            }
          }
        }
      );
    }
    else
    {
      info.jobName.forEach(name =>
      {
        jobs(name).forEach(
          job => {
            if (params[job.id]) {
              const filteredParams = paramConstants.cleanParams(
                params[job.id],
                [paramConstants.JENKINS_DISPATCHER_SCENARIO_NAME]);
              const scenarioName = filteredParams[dispatcherScenarioName];
              if (scenarioName)
              {
                exportScenarioNames.add(scenarioName.toLowerCase());
              }
            }
          }
        );
      });
    }
    return Array.from(exportScenarioNames);
  }
);

export const getScenarioNamesPartI = createSelector (
  getRegressionScenarioNames,
  (scenarioNames) => {
    const snPartIs = new Set([]);
    scenarioNames.forEach(
      sn => {
        snPartIs.add(sn.split('-')[0]);
      }
    );
    return Array.from(snPartIs);
  }
);

export const getScenarioNamesPartIIByPartI = createSelector (
  getRegressionScenarioNames,
  getMetricsPageInfo,
  (scenarioNames, info) => {
    const snPartIIsByPartI = {};

    scenarioNames.forEach(
      sn => {
        const snPartI = sn.toLowerCase().split('-')[0];
        const snPartII = info.jobName === jobNames.EXPORT ?
          sn.toLowerCase().split('-')[1] : sn.slice(snPartI.length + 1);
        if (snPartIIsByPartI[snPartI] === undefined)
        {
          snPartIIsByPartI[snPartI] = new Set([snPartII]);
        }
        else
        {
          snPartIIsByPartI[snPartI].add(snPartII);
        }
      }
    );

    return snPartIIsByPartI;
  }
);

export const getScenarioNamesPartIIIByPartINII = createSelector (
  getRegressionScenarioNames,
  (scenarioNames) => {
    const snPartIIIsByPartINII = {};

    scenarioNames.forEach(
      sn => {
        const snPartI = sn.toLowerCase().split('-')[0];
        const snPartII = sn.toLowerCase().split('-')[1];
        const index = snPartI.length + snPartII.length + 2;
        const snPartIII = sn.slice(index);

        if (snPartIIIsByPartINII[snPartI + snPartII] === undefined)
        {
          snPartIIIsByPartINII[snPartI + snPartII] = new Set([snPartIII]);
        }
        else
        {
          snPartIIIsByPartINII[snPartI + snPartII].add(snPartIII);
        }
      }
    );

    return snPartIIIsByPartINII;
  }
);


export const metricsFilteredJobs = createSelector(
  metricJobsByBuildType,
  metricsJobsByParamSimple,
  metricJobsByOutlierToggle,
  metricsJobsByImages,
  metricsJobsByCaseActions,
  metricsJobsByScenarioNames,
  getMetricsByDateRunCount,
  (byBuildsTypes, byParam, metricsByOutlier,
    byImages, byCaseActions, byScenarioNames, runCount) => memoize(
    ({
      jobName, toggles, nodes, caseName, action, image, snPartI,
      snPartII, snPartIII
    }) => {
      const filteredJobs = [];
      if (jobName === jobNames.EXPORT ||
          jobName === jobNames.CASE_AMENDING ||
        jobName === jobNames.CASE_AMENDING_KPP ||
        jobName === jobNames.JOBBENCHMARK)
      {
        const scenarioName = snPartI ?
          snPartIII ?
            (snPartI + '-' + snPartII + '-' + snPartIII) :
            (snPartI + '-' + snPartII) :
          snPartII;
        filteredJobs.push(
          flatten(byScenarioNames(jobName) && byScenarioNames(jobName)[scenarioName] ?
            byScenarioNames(jobName)[scenarioName].map(j => j) : []));
        return intersectionBy(...filteredJobs, j => j ? j.id : j)
          .sort((a, b) => a.id - b.id)
          .slice(-runCount);
      }

      if (!(toggles && nodes &&
          byBuildsTypes(jobName) &&
          metricsByOutlier(jobName))) {
        return [];
      }

      const types = constants.buildTypesBitFieldMapper(toggles);

      const caseAction = caseName + '|' + action;
      const jobsByCaseAction = byCaseActions[caseAction] ?
        byCaseActions[caseAction] : [];

      filteredJobs.push(flatten(types.map(t => byBuildsTypes(jobName)[t])));
      filteredJobs.push(metricsByOutlier(jobName));

      if (!nodes.includes('all'))
      {
        const byNodes = byParam({
          jobName: jobName,
          paramKey: paramConstants.NODE
        });
        filteredJobs.push(flatten(nodes.map(n => byNodes[n])));
      }

      if (jobName === jobNames.CASE_METRICS)
      {
        filteredJobs.push(byImages[image]);
      }
      else if (jobName === jobNames.PERFORMANCE)
      {
        filteredJobs.push(flatten(jobsByCaseAction.map(j => j)));
      }
      return intersectionBy(...filteredJobs, j => j ? j.id : j)
        .sort((a, b) => a.id - b.id)
        .slice(-runCount);
    }
  )
);

export const getMetricsFilteredJobs = createSelector(
  metricsFilteredJobs,
  getMetricsPageInfo,
  getMetricsByDateLowerLatestFetch,
  (jobs, info, lowestFetch) => {
    return jobs({ ...info, lowestFetch: lowestFetch });
  }
);

export const getCaseMetricsArtifactMetrics = createSelector(
  getMetricsFilteredJobs,
  metricsByJobIds,
  (jobs, metricsByJobIds) => {
    return jobs.map(j => {
      const metrics = metricsByJobIds[j.id];
      if (!metrics) return metrics;

      const ccfObj = metricConstants.getArtifactTimingObject(metrics, true);
      const ncfObj = metricConstants.getArtifactTimingObject(metrics, false);

      const ccfHuntersByGroupsByCarve =
        mapValues(ccfObj.timings, (t => t.Groups));
      const ncfHuntersByGroupsByCarve =
        mapValues(ncfObj.timings, (t => t.Groups));

      return {
        jobId: j.id,
        jobNumber: j.number.toString(),
        ccfHuntersByGroupsByCarve,
        ncfHuntersByGroupsByCarve,
      };
    });
  }
);

export const getCaseMetricsArtifactGroups = createSelector(
  getCaseMetricsArtifactMetrics,
  (metrics) => {
    if (!metrics) return [];
    const groups = metrics.reduce((result, metric) => {
      if (!metric) return [];
      const ccfGroups = utils.keysOfValuesReducer(metric.ccfHuntersByGroupsByCarve);
      const ncfGroups = utils.keysOfValuesReducer(metric.ncfHuntersByGroupsByCarve);
      return { ...result, ...ccfGroups, ...ncfGroups };
    }, {});
    return keys(groups).sort();
  }
);

export const getCaseMetricsArtifactHunters = createSelector(
  getCaseMetricsArtifactMetrics,
  (metrics) => {
    if (!metrics) return [];
    const hunters = metrics.reduce((result, metric) => {
      if (!metric) { return result; }
      const ccfHunters = metricConstants
        .getArtifactTimingHunters(metric.ccfHuntersByGroupsByCarve);
      const ncfHunters = metricConstants
        .getArtifactTimingHunters(metric.ncfHuntersByGroupsByCarve);
      return { ...result, ...ccfHunters, ...ncfHunters };
    }, {});
    return keys(hunters).sort();
  }
);

export const getCaseMetricsArtifactFilteredTimings = createSelector(
  getCaseMetricsArtifactMetrics,
  artifactsMetricsPageReducer.getArtifactsInfo,
  (metrics, info) => memoize(({ isCcf, carveType }) => {
    return metrics.map(metric => {
      if (!metric || !carveType) { return {}; }

      const relevantMetrics = isCcf ?
        metric.ccfHuntersByGroupsByCarve[carveType] :
        metric.ncfHuntersByGroupsByCarve[carveType];
      if (!relevantMetrics) { return {}; }

      if (info.inGroups) {
        return info.groups.reduce((result, group) => {
          if (relevantMetrics[group]) {
            result = { ...result, [group]: relevantMetrics[group] };
          }
          return result;
        }, {});
      } else {
        return info.hunters.reduce((result, hunter) => {
          const group = hunter.slice(0, hunter.indexOf('.'));
          if (relevantMetrics[group]) {
            result = { ...result, [hunter]: relevantMetrics[group][hunter] };
          }
          return result;
        }, {});
      }
    });
  })
);

export const getReleaseMetricsJobsByBuildId = createSelector(
  buildsByTypesAndProducts,
  jobIdsByBuildId,
  jobsById,
  paramsByJobIds,
  releaseMetricsPageReducer.getReleaseMetricsInfo,
  (builds, jobIds, jobs, params, info) => memoize(({ jobName, product }) => {
    if (!(product)) { return {}; }

    // narrow builds down to the specific type and product given
    const buildsByProduct = builds && builds[constants.LATEST_RELEASE];
    const relevantBuilds = buildsByProduct &&
      buildsByProduct[product];
    if (!relevantBuilds) { return {}; }

    const relatedJobsByBuildId = relevantBuilds.reduce((result, build) => {
      const jobIdsFromBuild = jobIds[build.id];
      if (!jobIdsFromBuild) { return result; }

      const relevantJobs = jobIdsFromBuild
        .map(jobId => jobs[jobId])
        .filter(job => {
          // filter for relevant jobs only
          if (!(job && job.name === jobName)) {
            return false;
          }

          const param = params && params[job.id];
          if (!param) { return false; }

          if (jobName === jobNames.CASE_METRICS) {
            // filter out some jobs without params
            if (!param[paramConstants.IMAGEFILE]) return false;

            // filter for jobs that ran on selected scenario
            const image = param[paramConstants.IMAGEFILE] || '';
            const lastIndex = image.lastIndexOf('.');
            const imageName = image.slice(0, lastIndex);
            return imageName.toLowerCase() === info.scenario;
          } else if (jobName === jobNames.PERFORMANCE) {
            return param[paramConstants.JENKINS_CASE_FILES] === info.case;
          }
        });

      // if no jobs found then skip
      if (relevantJobs.length < 1) { return result; }
      // for performance test runs, multiple runs will contain the different metrics
      // so include all, not only the most recent (i.e. last) job
      result[build.version] = jobName === jobNames.CASE_METRICS ?
        last(relevantJobs) :
        relevantJobs;
      return result;
    }, {});
    return relatedJobsByBuildId;
  }));

export const getReleaseMetricsScanMetrics = createSelector(
  getReleaseMetricsJobsByBuildId,
  releaseMetricsPageReducer.getReleaseMetricsInfo,
  metricsByJobIds,
  paramsByJobIds,
  (jobs, info, metricsByJobIds, paramsByJobIds) => {
    const memoObj = {
      jobName: jobNames.CASE_METRICS,
      product: info.product
    };
    const relevantJobsByVersion = jobs(memoObj);
    return keys(relevantJobsByVersion).map(version => {
      // filter out builds with versions older than selected by user
      const selectedVersion = info.sinceVersion ? info.sinceVersion : '0.0.0.0';
      if (utils.versionComparer(version, selectedVersion) < 0) return undefined;

      const job = relevantJobsByVersion[version];
      const metrics = metricsByJobIds[job.id];
      if (!metrics) return undefined;

      const params = paramsByJobIds[job.id];
      return {
        productVersion: version,
        complementVersion: params && info.product === constants.PRODUCTS.PROCESS ?
          params[paramConstants.IEF_ENGINE_VERSION] :
          params[paramConstants.PROCESS_VERSION],
        jobId: job.id,
        jobNumber: job.number.toString(),
        ccf: {
          search: metricConstants.getSearchDuration(metrics, true) || 0,
          hitCount: metricConstants.getHitCount(metrics, true) || 0,
          caseSize: metricConstants.getCaseSize(metrics, true) || 0
        },
        ncf: {
          search: metricConstants.getSearchDuration(metrics, false) || 0,
          hitCount: metricConstants.getHitCount(metrics, false) || 0,
          caseSize: metricConstants.getCaseSize(metrics, false) || 0
        }
      };
    })
      .filter(m => m)
      .sort((a, b) => utils.versionComparer(a.productVersion, b.productVersion));
  }
);

/**
 * Builds an array of objects describing the metrics for filtered
 * CaseMetrics jobs for display
 *
 * Returned are:
 *  - relevant job details
 *  - whether or not the job ran on node matching conditions on SCAN ticket
 *  - relevant metrics separated by case type
 */
export const getCaseMetricsScanMetrics = createSelector(
  getMetricsFilteredJobs,
  metricsByJobIds,
  paramsByJobIds,
  scansByJobId,
  (jobs, metricsByJobIds, paramsByJobIds, scansByJobId) => {
    return jobs.map(j => {
      const metrics = metricsByJobIds[j.id];
      if (!metrics) return metrics;

      // try and find scan that the job ran on to determine if
      // job label matches scan label, save value into metric
      // if yes we care about timings else treat as 'artifact only'
      const params = paramsByJobIds[j.id];
      const scan = scansByJobId[j.id];
      const label = params[paramConstants.JENKINS_LABEL];

      const result = {
        jobId: j.id,
        jobNumber: j.number.toString(),
        runnerNodeScanMismatch: scanConstants.unmatchedNodeLabel(scan, label),
        ccf: {
          countsByArtifact: metricConstants.getArtifactHitCounts(metrics, true),
          search: metricConstants.getSearchDuration(metrics, true) || 0,
          runtime: (metricConstants.getSearchDuration(metrics, true) || 0) +
            (metricConstants.getDecryptionDuration(metrics, true) || 0),
          hitCount: metricConstants.getHitCount(metrics, true) || 0,
          caseSize: metricConstants.getCaseSize(metrics, true) || 0,
          resourceUsage: metricConstants.getResourceUsages(metrics, true)
        },
        ncf: {
          countsByArtifact: metricConstants.getArtifactHitCounts(metrics, false),
          search: metricConstants.getSearchDuration(metrics, false) || 0,
          runtime: (metricConstants.getSearchDuration(metrics, false) || 0) +
            (metricConstants.getDecryptionDuration(metrics, false) || 0),
          hitCount: metricConstants.getHitCount(metrics, false) || 0,
          caseSize: metricConstants.getCaseSize(metrics, false) || 0,
          sourceCount: metricConstants.getSourceCount(metrics, false) || 0,
          sourceAttributeCount:
            metricConstants.getSourceAttributeCount(metrics, false) || 0,
          resourceUsage: metricConstants.getResourceUsages(metrics, false)
        }
      };
      return result;
    });
  }
);

export const getPerformanceMetrics = createSelector(
  getMetricsFilteredJobs,
  getMetricsPageType,
  getMetricsPageInfo,
  metricsByJobIds,
  (jobs, type, info, metricsByJobIds) => {
    return jobs.map(j => {
      const metrics = metricsByJobIds[j.id];
      if (!metrics) return metrics;

      if (type === pageTypes.PERFORMANCEMETRICS)
      {
        return {
          jobId: j.id,
          jobNumber: j.number.toString(),
          duration: metricConstants.getPerformanceDuration(
            metrics, info.caseName + '|' + info.action)
        };
      }
      if (type === pageTypes.EXPORTTESTS)
      {
        return {
          jobId: j.id,
          jobNumber: j.number.toString(),
          duration: metricConstants.getExportDuration(metrics)
        };
      }
      if (type === pageTypes.CASEAMENDINGTESTS || type === pageTypes.CASEAMENDINGKPPTESTS)
      {
        return {
          jobId: j.id,
          jobNumber: j.number.toString(),
          duration: metricConstants.getCaseAmendingDuration(metrics)
        };
      }
      if (type === pageTypes.JOBBENCHMARK) {
        return {
          jobId: j.id,
          jobNumber: j.number.toString(),
          duration: metricConstants.getJobBenchmarkDuration(metrics)
        };
      }
    }
    );
  }
);

/**
 * Builds an array of objects describing the metrics for filtered
 * EngineMetrics jobs for display
 *
 * Returned are:
 *  - relavent job details
 *  - whether or not the job ran on node matching conditions on SCAN ticket
 *  - relevant metrics separated by case type
 */
export const getCaseMetricsEngineMetrics = createSelector(
  getMetricsFilteredJobs,
  metricsByJobIds,
  paramsByJobIds,
  scansByJobId,
  (jobs, metricsByJobIds, paramsByJobIds, scansByJobId) => {
    return jobs.map(j => {
      const metrics = metricsByJobIds[j.id];
      if (!metrics) return metrics;

      // try and find scan that the job ran on to determine if
      // job label matches scan label, save value into metric
      // if yes we care about timings else treat as 'artifact only'
      const params = paramsByJobIds[j.id];
      const scan = scansByJobId[j.id];
      const label = params[paramConstants.JENKINS_LABEL];

      // cheat the two timings into engine timing object for later
      const ccfTiming = metricConstants.getDetailedEngineTimingObject(metrics, true);
      if (!isEmpty(ccfTiming)) {
        ccfTiming['Indexing'] = metricConstants.getIndexingDuration(metrics, true);
        ccfTiming['Decrypting'] = metricConstants.getDecryptionDuration(metrics, true);
      }
      const ncfTiming = metricConstants.getDetailedEngineTimingObject(metrics, false);
      if (!isEmpty(ncfTiming)) {
        ncfTiming['Indexing'] = metricConstants.getIndexingDuration(metrics, false);
        ncfTiming['Decrypting'] = metricConstants.getDecryptionDuration(metrics, false);
      }

      return {
        jobId: j.id,
        jobNumber: j.number.toString(),
        runnerNodeScanMismatch: scanConstants.unmatchedNodeLabel(scan, label),
        ccfTiming,
        ncfTiming
      };
    });
  }
);

export const getArtifactTimingMetrics = createSelector(
  getMetricsFilteredJobs,
  metricsByJobIds,
  (jobs, metricsByJobIds) => {
    return jobs.map(j => {
      const metrics = metricsByJobIds[j.id];
      if (!metrics) return metrics;
      const ccfTiming = metricConstants.getSummedWorkerThreadDequeueTimes(metrics, true);
      const ncfTiming = metricConstants.getSummedWorkerThreadDequeueTimes(metrics, false);
      return {
        jobId: j.id,
        jobNumber: j.number.toString(),
        ccfTiming,
        ncfTiming
      };
    });
  }
);

export const metricJobsForHighlights = createSelector(
  getMetricsFilteredJobs,
  paramsByJobIds,
  (filteredjobs, paramsById) => memoize(
    ({ buildFilter }) => {
      if (!(buildFilter)) return [];

      let target = [];
      if (buildFilter.startsWith('d:'))
      {
        buildFilter.split(',').forEach( filter => target.push(filter.slice(2)));
      }
      else
      {
        target = buildFilter;
      }

      let toCheckParams = [];
      if (buildFilter.startsWith('d:')) {
        toCheckParams = [paramConstants.JENKINS_DISPATCHER_JOB_NAME_NUMBER];
      } else if (isNaN(buildFilter)) {
        toCheckParams = [paramConstants.TOPICBRANCH];
      } else {
        toCheckParams = [
          paramConstants.PROCESS_VERSION,
          paramConstants.IEF_ENGINE_VERSION
        ];
      }

      return filteredjobs.filter(j => {
        const params = toCheckParams
          .map(p => paramsById[j.id] ? paramsById[j.id][p] : '');

        return params.some(s => {
          if (s)
          {
            for (let i = 0; i < target.length; i++)
            {
              if (s.endsWith(target[i]))
              {
                return true;
              }
            }
          }
          return false;
        });
      });
    }
  )
);

export const getMetricJobsForHighlights = createSelector(
  metricJobsForHighlights,
  getMetricsPageInfo,
  (jobs, info) => {
    return jobs({ ...info });
  }
);

export const getCaseMetricsArtifactHitDiffs = createSelector(
  getCaseMetricsScanMetrics,
  groupJobRelationshipsByParentJobId,
  metricsByJobIds,
  (metrics, jobRelationships, metricsByJobIds) => {
    const hitDiffs = Array(metrics.length);
    for (let i = 0; i < metrics.length; i++) {
      if (!metrics[i]) { return []; }
      let foundNcfDiff = false;
      let foundCcfDiff = false;
      if (jobRelationships) {
        const jobRelationshipsById = jobRelationships[metrics[i].jobId];
        let jobMetrics = {};
        (jobRelationshipsById || []).forEach(jr => {
          const childMetrics = metricsByJobIds[jr.child_job_id];
          if (childMetrics) {
            jobMetrics = Object.assign(childMetrics, jobMetrics);
          }
        });
        const ncfDiffMetricsKeys = keys(jobMetrics).filter(key => key.includes('NCF_'));
        const ccfDiffMetricsKeys = keys(jobMetrics).filter(key => key.includes('CCF_'));
        foundNcfDiff = ncfDiffMetricsKeys.some(key => jobMetrics[key] === 'fail');
        foundCcfDiff = ccfDiffMetricsKeys.some(key => jobMetrics[key] === 'fail');
      }
      if (i === 0 || !metrics[i - 1]) {
        hitDiffs[i] = { foundNcfDiff, foundCcfDiff };
        continue;
      }
      const ccfDiffs = metricConstants.getDiffs(
        metrics[i - 1].ccf.countsByArtifact,
        metrics[i].ccf.countsByArtifact,
      );
      const ncfDiffs = metricConstants.getDiffs(
        metrics[i - 1].ncf.countsByArtifact,
        metrics[i].ncf.countsByArtifact,
      );
      const ccfNcfDiffs = metricConstants.getDiffs(
        metrics[i].ccf.countsByArtifact,
        metrics[i].ncf.countsByArtifact,
      );
      const deltaDiffs = metricConstants.getDiffs(
        ccfDiffs,
        ncfDiffs,
      );
      hitDiffs[i] = {
        ccfDiffs, ncfDiffs, ccfNcfDiffs,
        deltaDiffs, foundNcfDiff, foundCcfDiff
      };
    }
    return hitDiffs;
  }
);

export const getCaseMetricsHitChartPointColors = createSelector(
  getCaseMetricsArtifactHitDiffs,
  (hitDiffs) => {
    const colors = hitDiffs.map(hitDiff => {
      // change in ccf hits not the same as change in ncf hits
      // and ncf not equal to ccf, flag red
      if (some(hitDiff.deltaDiffs,
        (d, index) => {
          return d !== 0 && hitDiff.ccfNcfDiffs[index] &&
          hitDiff.ccfNcfDiffs[index] !== 0;
        }
      )) {
        return [colours.METRICS_CHARTS.RED, colours.METRICS_CHARTS.RED];
      }

      //default colours
      let ccfColor = colours.METRICS_CHARTS.CCF_DEFAULT;
      let ncfColor = colours.METRICS_CHARTS.NCF_DEFAULT;

      // change in ccf or ncf hits compared to prev job, flag yellow
      if (some(hitDiff.ccfDiffs, d => d !== 0)) {
        ccfColor = colours.METRICS_CHARTS.YELLOW;
      }
      else if (hitDiff.foundCcfDiff) {
        ccfColor = colours.METRICS_CHARTS.RED;
      }
      if (some(hitDiff.ncfDiffs, d => d !== 0)) {
        ncfColor = colours.METRICS_CHARTS.YELLOW;
      }
      else if (hitDiff.foundNcfDiff) {
        ncfColor = colours.METRICS_CHARTS.RED;
      }
      return [ccfColor, ncfColor];
    });
    return colors;
  }
);

export const getCaseMetricsDurationChartPointColors = createSelector(
  getMetricsFilteredJobs,
  paramsByJobIds,
  metricsByJobIds,
  groupJobRelationshipsByParentJobId,
  (filteredjobs, paramsById, metricsById, jobRelationshipsByParentId) => {
    return filteredjobs.map(job => {
      const params = paramsById[job.id];

      const jobRelationships = jobRelationshipsByParentId[job.id];
      const jobRelationshipsChildIds = [];
      jobRelationships &&
        jobRelationships.forEach(jr => {
          jobRelationshipsChildIds.push(jr.child_job_id);
        });
      let diffMetrics = {};
      jobRelationshipsChildIds.forEach(id => {
        if (metricsById[id]) {
          diffMetrics = Object.assign(metricsById[id], diffMetrics);
        }
      });

      const ncfDiffMetricsKeys = keys(diffMetrics).filter(key => key.includes('NCF_'));
      const ccfDiffMetricsKeys = keys(diffMetrics).filter(key => key.includes('CCF_'));
      let foundNcfDiff = false;
      let foundCcfDiff = false;
      let errorCodeDiff = false;
      ncfDiffMetricsKeys.forEach(key => {
        if (diffMetrics[key] === 'fail') {
          foundNcfDiff = true;
        } else if (
          key.endsWith(
            metricConstants.RUN_CASE_METRICS_DIFF_STATUS_CODE_SUFFIX) &&
            diffMetrics[key] !== 'OK') {
          errorCodeDiff = true;
        }
      });
      ccfDiffMetricsKeys.forEach(key => {
        if (diffMetrics[key] === 'fail') {
          foundCcfDiff = true;
        } else if (
          key.endsWith(
            metricConstants.RUN_CASE_METRICS_DIFF_STATUS_CODE_SUFFIX) &&
            diffMetrics[key] !== 'OK') {
          errorCodeDiff = true;
        }
      });

      if (params[paramConstants.ERROR_CODE]) {
        return Array(4).fill(colours.METRICS_CHARTS.RED);
      }
      if (errorCodeDiff) {
        return Array(4).fill(colours.METRICS_CHARTS.RED);
      }
      if (foundNcfDiff && !foundCcfDiff) {
        return [
          colours.METRICS_CHARTS.CCF_DEFAULT,
          colours.METRICS_CHARTS.CCF_DEFAULT,
          colours.METRICS_CHARTS.YELLOW,
          colours.METRICS_CHARTS.YELLOW,
        ];
      }
      if (foundCcfDiff && !foundNcfDiff) {
        return [
          colours.METRICS_CHARTS.YELLOW,
          colours.METRICS_CHARTS.YELLOW,
          colours.METRICS_CHARTS.NCF_DEFAULT,
          colours.METRICS_CHARTS.NCF_DEFAULT,
        ];
      }
      if (foundCcfDiff && foundNcfDiff) {
        return Array(4).fill(colours.METRICS_CHARTS.YELLOW);
      }

      return [
        colours.METRICS_CHARTS.CCF_DEFAULT,
        colours.METRICS_CHARTS.CCF_DEFAULT,
        colours.METRICS_CHARTS.NCF_DEFAULT,
        colours.METRICS_CHARTS.NCF_DEFAULT,
      ];
    });
  }
);

export const getCcfNcfBuildPageOrder = createSelector(
  getBuildInfo,
  getShowBuildComplement,
  (buildInfo, showBuildComplement) => {
    const types = ['ccf', 'ncf'];
    const isCcf = constants.isProductCcf(buildInfo.product);
    const main = types[isCcf ? 0 : 1];
    const other = types[isCcf ? 1 : 0];

    return {
      main,
      other: showBuildComplement ? other : undefined
    };
  }
);

export const getMetricsPageHighlights = createSelector(
  getMetricsPageSelectedJob,
  getMetricJobsForHighlights,
  (selectedJobs, jobFilter) => {
    const highlights = [];

    for (let i = 0; i < jobFilter.length; i++) {
      highlights.push({
        xAxisValue: jobFilter[i].number.toString(),
        color: colours.METRICS_CHARTS.HIGHLIGHT_2
      });
    }

    if (selectedJobs[0]) {
      const col = selectedJobs[0].index >= 0 ?
        colours.METRICS_CHARTS.RED :
        colours.METRICS_CHARTS.GIVEN_JOB_HIGHLIGHT;
      highlights.push({
        xAxisValue: selectedJobs[0].value,
        color: col
      });
    }
    if (selectedJobs[1]) {
      highlights.push({
        xAxisValue: selectedJobs[1].value,
        color: colours.METRICS_CHARTS.HIGHLIGHT_1
      });
    }
    return highlights;
  }
);


export const metricJobs = createSelector(
  getBuildPageBuilds,
  jobsById,
  jobIdsByBuildId,
  (builds, jobsById, jobIdsByBuildId) => {
    const jobIds = flatten(builds.map(b => jobIdsByBuildId[b.id]));
    return uniq(jobIds.map(id => jobsById[id])
      .filter(j => j && j.name === jobNames.CASE_METRICS));
  }
);
export const baselineMetricJobs = createSelector(
  getBaselineBuildInfo,
  getBuildPageBaselineBuilds,
  jobsById,
  jobIdsByBuildId,
  getLatestBaselineJobs,
  (baselineBuildInfo, builds, jobsById, jobIdsByBuildId, latestBaselineJobs) => {
    if (baselineBuildInfo.buildType === constants.LATEST_BY_IMAGE) {
      return latestBaselineJobs;
    }

    const jobIds = flatten(builds.filter(b => b).map(b => jobIdsByBuildId[b.id]));
    return uniq(jobIds.map(id => jobsById[id])
      .filter(j => j !== undefined));
  }
);

export const getAllBuildPageJobs = createSelector(
  metricJobs,
  baselineMetricJobs,
  (metricJobs, baselineMetricJobs) =>
    utils.uniqArrayCombinator(j => j.id, metricJobs, baselineMetricJobs)
);

const getBaselineJobsByImage = createSelector(
  baselineMetricJobs,
  paramsByJobIds,
  (baselineMetricJobs, paramsByJobIds) =>
    baselineMetricJobs.reduce((result, job) => {
      const params = paramsByJobIds[job.id];
      const image = params && params[paramConstants.IMAGEFILE];
      if (image) {
        result[image] = job;
      }
      return result;
    }, {})
);

export const getBaselineBuildNumberByImage = createSelector(
  getBaselineJobsByImage,
  buildsById,
  buildIdsByJobId,
  (baselineJobsByImage, buildsById, buildIdsByJobId) => {
    return Object.keys(baselineJobsByImage)
      .reduce((result, i) => {
        const job = baselineJobsByImage[i];
        const builds = (buildIdsByJobId[job.id] || []).map(id => buildsById[id])
          .filter(x => x);
        const ncf = builds.find(b => !constants.isProductCcf(b.product));
        const ccf = builds.find(b => constants.isProductCcf(b.product));

        result[i] = {
          ncf: ncf ? ncf.build : undefined,
          ccf: ccf ? ccf.build : undefined
        };
        return result;
      }, {});
  }
);

export const getRelativeMetrics = createSelector(
  (state) => getBaselineBuildInfo(state).buildType,
  metricJobs,
  getBaselineJobsByImage,
  paramsByJobIds,
  scansByJobId,
  metricsByJobIds,
  getHighlightedMetricImage,
  groupJobRelationshipsByParentJobId,
  (
    baselineBuildType,
    metricsJobs,
    baselineJobsByImage,
    paramsByJobIds,
    scansByJobId,
    metricsByJobIds,
    highlightedImage,
    jobRelationships
  ) => reducerHelpers.getRelativeMetricsFunc(
    baselineBuildType,
    metricsJobs,
    baselineJobsByImage,
    paramsByJobIds,
    scansByJobId,
    metricsByJobIds,
    highlightedImage,
    jobRelationships
  )
);

export const getRelativeMetricsByScanKeys = (state, scanKeys) => {
  const metrics = getRelativeMetrics(state);
  return metrics.filter(m => m.latest && scanKeys.includes(m.scanKey));
};

export const getVisibleMetrics = createSelector(
  getRelativeMetrics,
  getLatestMetricsOnly,
  getConcerningMetricsOnly,
  getCcfNcfBuildPageOrder,
  (metrics, latestMetricsOnly, concerningMetricsOnly, ccfNcfOrder) => {
    const visibleMetrics = metrics.filter(m => {
      if (latestMetricsOnly && !m.latest) {
        return false;
      }

      const mainIsConcerning = m[ccfNcfOrder.main].concerning;
      const otherIsConcerning = ccfNcfOrder.other ?
        m[ccfNcfOrder.other].concerning :
        false;
      if (concerningMetricsOnly && !mainIsConcerning && !otherIsConcerning) {
        return false;
      }

      return true;
    });
    return visibleMetrics;
  }
);

const expandMetricsByType = (metrics, typeVisibility) => {
  return metrics.reduce((result, m) => {
    const { ncf: ignored, ccf: _ignored, ...info } = m;

    result.push({
      ...info,
      ...m[typeVisibility.main],
      image: `${m.image} ${typeVisibility.main.toUpperCase()}`
    });

    if (typeVisibility.other) {
      result.push({
        ...info,
        ...m[typeVisibility.other],
        image: `${m.image} ${typeVisibility.other.toUpperCase()}`
      });
    }

    return result;
  }, []);
};

const getChartMetricsForProp = (metrics, typeVisibility, getPropValue, propName) => {
  const parseMetric = (metric) => {
    const propValue = getPropValue(metric);
    if (propValue === null && propValue === undefined) {
      return undefined;
    }

    return {
      image: metric.image,
      highlight: metric.highlight,
      durationPercent: metric.durationMetrics.percent,
      [propName]: parseInt(propValue),
    };
  };

  const newMetrics = expandMetricsByType(metrics, typeVisibility)
    .map(m => parseMetric(m))
    .filter(x => x);

  newMetrics.sort((a, b) => (a.durationPercent - b.durationPercent));

  return newMetrics;
};

export const getDurationMetricsInfo = createSelector(
  getVisibleMetrics,
  getCcfNcfBuildPageOrder,
  (filteredMetrics, typeVisibility) => {
    const metrics = getChartMetricsForProp(
      filteredMetrics,
      typeVisibility,
      (metric) => metric.durationMetrics && metric.durationMetrics.percent,
      'durationPercent'
    );

    const series = metrics
      .map(m => {
        let colour = colours.colours.blue;

        if (m.durationPercent > 5) {
          colour = colours.colours.red;
        } else if (m.durationPercent > 0) {
          colour = colours.colours.orange;
        }

        return {
          label: m.image,
          colour: colour,
          isHighlighted: m.highlight
        };
      });

    const { max, min } = metricConstants.getMetricExtremes(metrics, 'durationPercent');

    return {
      metrics,
      series,
      max: Math.max(20, max),
      min: Math.min(-20, min)
    };
  }
);

export const getHitCountMetricsInfo = createSelector(
  getVisibleMetrics,
  getCcfNcfBuildPageOrder,
  (filteredMetrics, typeVisibility) => {
    const metrics = getChartMetricsForProp(
      filteredMetrics,
      typeVisibility,
      (metric) => metric.hitCountMetrics && metric.hitCountMetrics.diff,
      'hitCountDiff'
    );

    const series = metrics.map(m => ({
      label: m.image,
      colour: colours.colours.red,
      isHighlighted: m.highlight
    }));

    const { max, min } = metricConstants.getMetricExtremes(metrics, 'hitCountDiff');

    return {
      metrics,
      series,
      max: Math.min(100, max),
      min: Math.max(-100, min)
    };
  }
);

export const getSourceCountsMetricsInfo = createSelector(
  getVisibleMetrics,
  getCcfNcfBuildPageOrder,
  (filteredMetrics, typeVisibility) => {
    const metrics = getChartMetricsForProp(
      filteredMetrics,
      typeVisibility,
      (metric) => metric.sourceCountMetrics && metric.sourceCountMetrics.diff,
      'sourceCountDiff'
    );

    const series = metrics.map(m => ({
      label: m.image,
      colour: colours.colours.red,
      isHighlighted: m.highlight
    }));

    const { max, min } = metricConstants.getMetricExtremes(metrics, 'sourceCountDiff');

    return {
      metrics,
      series,
      max: Math.min(100, max),
      min: Math.max(-100, min)
    };
  }
);

export const getSourceAttributeCountsMetricsInfo = createSelector(
  getVisibleMetrics,
  getCcfNcfBuildPageOrder,
  (filteredMetrics, typeVisibility) => {
    const metrics = getChartMetricsForProp(
      filteredMetrics,
      typeVisibility,
      (metric) => metric.sourceAttributeCountMetrics &&
       metric.sourceAttributeCountMetrics.diff,
      'sourceAttributeCountDiff'
    );

    const series = metrics.map(m => ({
      label: m.image,
      colour: colours.colours.red,
      isHighlighted: m.highlight
    }));

    const { max, min } =
      metricConstants.getMetricExtremes(metrics, 'sourceAttributeCountDiff');

    return {
      metrics,
      series,
      max: Math.min(100, max),
      min: Math.max(-100, min)
    };
  }
);

export const uniqueMetricJobImages = createSelector(
  metricJobs,
  paramsByJobIds,
  (jobs, paramsByJobIds) => uniq(jobs
    .map(j => jobConstants.getImageFileName(j, paramsByJobIds))
    .filter(n => n !== undefined))
);

export const getMetricsTableData = createSelector(
  getVisibleMetrics,
  getMetricsSorter,
  (metrics, sorter) => metricConstants
    .sortMetrics(metrics, sorter)
    .map(m => {
      return {
        ...m,
        hash: getHash(m.image + m.createdDate.toISOString())
      };
    })
);

export const getBuildPageInstallerFileDifferences = createSelector(
  getBuildPageBuilds,
  getBuildPageBaselineBuilds,
  installerDifferencesReducer.installerDifferencesByBuildIds,
  (builds, baselineBuilds, installerDifferences) => {
    let files = [];
    for (let i = 0; i < builds.length; ++i) {
      const build = builds[i];
      const baselineBuild = baselineBuilds[i];

      if (!build ||
        !baselineBuild ||
        !installerDifferences ||
        !installerDifferences[build.id]
      ) {
        continue;
      }

      const file = installerDifferences[build.id][baselineBuild.id];
      if (!file) {
        continue;
      }

      files = files.concat(file);
    }

    return files;
  }
);

export const getBuildPageInstallerFileMetrics = createSelector(
  getBuildPageInstallerFileDifferences,
  (files) => {
    const metrics = {
      added: {
        expected: 0,
        unexpected: 0
      },
      removed: {
        expected: 0,
        unexpected: 0
      },
      noFiles: {
        buildId: 0,
        baselineBuildId: 0
      }
    };

    for (let i = 0; i < files.length; ++i) {
      const file = files[i];
      const fileId = file.id;
      if (fileId < 0 && file.product !== 'examine') {
        if (fileId < -1)
          metrics.noFiles.baselineBuildId = 1;
        if (fileId % 2 !== 0)
          metrics.noFiles.buildId = 1;
        continue;
      }
      if (file.added && file.expected) {
        ++metrics.added.expected;
      } else if (file.added) {
        ++metrics.added.unexpected;
      } else if (file.expected) {
        ++metrics.removed.expected;
      } else {
        ++metrics.removed.unexpected;
      }
    }

    return metrics;
  }
);

export const getStatistics = createSelector(
  getRelativeMetrics,
  getCcfNcfBuildPageOrder,
  (metrics, ccfNcfBuildOrder) => {
    if (metrics.length === 0) {
      return {
        median: null,
        average: null,
        maxReduction: null,
        minReduction: null,
        maxImprovement: null,
        minImprovement: null
      };
    }

    const type = ccfNcfBuildOrder.main;
    const durationPercents = metrics
      .filter(m =>
        m[type].durationMetrics.current > 30 &&
        m[type].durationMetrics.baseline > 30
      ).map(m => ({
        value: m[type].durationMetrics.percent,
        image: m.image
      }))
      .filter(p => !isNaN(p.value) && p.value < 10000 && p.value !== -100)
      .sort((a, b) => a.value - b.value);

    const reductions = durationPercents.filter(m => m.value > 0);
    const improvements = durationPercents.filter(m => m.value < 0);

    const len = durationPercents.length;
    const sum = durationPercents.reduce((acc, p) => acc + p.value, 0);
    const average = Math.round((sum / len) * 100) / 100;

    const median = len % 2 ?
      durationPercents[Math.floor(len / 2) + 1] :
      durationPercents[len / 2];

    let maxReduction = {
      value: 0,
      image: null
    };
    let minReduction = {
      value: Infinity,
      image: null
    };

    let maxImprovement = { ...maxReduction };
    let minImprovement = {
      value: -Infinity,
      image: null
    };

    for (let i = 0; i < reductions.length; i++) {
      if (reductions[i].value < minReduction.value) {
        minReduction = reductions[i];
      }
      if (reductions[i].value > maxReduction.value) {
        maxReduction = reductions[i];
      }
    }

    for (let i = 0; i < improvements.length; i++) {
      if (improvements[i].value > minImprovement.value) {
        minImprovement = improvements[i];
      }
      if (improvements[i].value < maxImprovement.value) {
        maxImprovement = improvements[i];
      }
    }

    return {
      median,
      average,
      maxReduction,
      minReduction,
      maxImprovement,
      minImprovement
    };
  }
);

export const getDispatchersByDispatcherJobName = createSelector(
  dispatchersByTypesAfterCaseMetricsDate,
  getMetricsDispatcherJobName,
  paramsByJobIds,
  jobsById,
  getMetricsJobName,
  getMetricsPageType,
  getMetricsDispatcherType,
  scenarioReducer.groupDispatchersByScenarioName,
  getMetricsPageDropdownFirstSelected,
  getMetricsPageInfo,
  (dispatchers, dispatcherJobName, params, jobs, jobName, pageType,
    dispatcherType, dispatchersByScenName, selectedPair, pageInfo) => {
    let dispatcherSet = dispatchers[dispatcherType] || [];

    // if the image dropdown was selected firt
    // then the dispatchers listed in the dropdown are first filtered
    // for dispatchers that ran the scenario only
    if (selectedPair === metricsPagesHelper.IMAGE_MARKER && pageInfo.image) {
      dispatcherSet = dispatchersByScenName[pageInfo.image] || [];
    }
    // else dispatchers left unfiltered dispatchers

    const result = dispatcherSet.reduce(
      (acc, dispatcher) => {
        const param = params[dispatcher.job_id];

        let job = jobs[dispatcher.job_id];

        // this is the check that decides if a dispatcher is really
        // supposed to be treated x_case_metrics or x_engine_metrics
        if (pageType === pageTypes.CASEMETRICS ||
          pageType === pageTypes.ENGINEMETRICS ||
          pageType === pageTypes.ARTIFACTSMETRICS) {
          if (!job || (job.name !== dispatcherJobName && job.name !== jobName)) {
            job = null;
          }
        }

        let name = '';
        if (param)
          name = param[paramConstants.JENKINS_TRIGGER_BY] ||
           param[paramConstants.DISPATCHEDBY] || '';
        acc.push({
          id: dispatcher.id,
          number: job ? job.number : 0,
          jobId: dispatcher.job_id,
          name: name.replace('_', '-'),
          scenarioCount: dispatcher.scenario_count
        });
        return acc;
      }, []).filter(d => d.number !== 0);

    return result;
  }
);


// WEBPACK FOOTER //
// src/reducers/index.js